import { initializeApp } from 'firebase/app'

export const app = initializeApp({
  apiKey: 'AIzaSyAu41s4ST0yZHYOBcsFbRxcTyfbojWJx8k',
  authDomain: 'lama-demo.firebaseapp.com',
  projectId: 'lama-demo',
  storageBucket: 'lama-demo.appspot.com',
  messagingSenderId: '888524152302',
  appId: '1:888524152302:web:e7fd37cb01d82bd2b042ff',
  measurementId: 'G-Y0KW16LKM9'
})
